import type { AppSettings } from '../appSettings';
import { useAppSettings } from './useAppSettings';

export function useFeatureToggles(): AppSettings['features'] {
  const { features } = useAppSettings();
  return features;
}
